import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/list-master/areas";

export const Route = createFileRoute("/admin/_list-master/areas")({
  component: Page,
});
